import { useEffect } from "react";
import { SEO } from "@/components/SEO";

const POINTS = [
  "Founder Readoo è un riconoscimento simbolico e gratuito, mostrato nel profilo di chi si è registrato a Readoo durante la sua fase iniziale.",
  "Non dà diritto a premi, denaro, rimborsi, quote, sconti o altri vantaggi garantiti, né oggi né in futuro.",
  "I Founder possono avere accesso prioritario e in anteprima alle novità di Readoo (nuove funzioni, sezioni o programmi), quando disponibili. Tempi, modi e durata sono decisi liberamente da Readoo e possono essere regolati da condizioni proprie.",
  "Readoo può chiudere le nuove iscrizioni come Founder, modificare o interrompere il riconoscimento in qualsiasi momento.",
  "Il badge è personale e non può essere ceduto. Se l'account viene eliminato, il badge non viene conservato.",
  "Condividere il badge sui social è libero e non comporta compensi di alcun tipo.",
];

export default function Termini() {
  useEffect(() => {
    if (window.location.hash === "#founder") document.getElementById("founder")?.scrollIntoView({ block: "start" });
  }, []);
  return (
    <div data-testid="terms-page" className="max-w-[760px] mx-auto px-4 sm:px-6 lg:px-8 pt-10 sm:pt-14 pb-16">
      <SEO title="Termini" description="Termini di Readoo: condizioni del riconoscimento Founder Readoo." />
      <p className="font-mono text-[11px] font-bold uppercase tracking-wider text-brand mb-3">Termini</p>
      <h1 className="font-serif text-4xl sm:text-5xl font-semibold leading-tight text-onSurface">Termini di Readoo</h1>
      <section id="founder" data-testid="terms-founder" className="mt-10 scroll-mt-28">
        <h2 className="font-serif text-2xl font-semibold text-onSurface">Founder Readoo</h2>
        <ul className="mt-4 space-y-3 list-disc pl-5 text-base leading-relaxed text-onSurfaceSecondary">
          {POINTS.map((p, i) => <li key={i} data-testid={`terms-founder-point-${i}`}>{p}</li>)}
        </ul>
      </section>
    </div>
  );
}
